import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="container py-5" style={{ maxWidth: 800 }}>
      <h1 className="mb-2">Privacy Policy</h1>
      <p className="text-muted mb-4">Last updated: September 2026</p>

      <p>
        This Privacy Policy applies to the <strong>GoDhamma (走，修行吧！)</strong> mobile
        application, operated by Pertubuhan Meditasi Shi Ne Ling, Malaysia.
      </p>

      <hr />

      <h4 className="mt-4">1. Information We Collect</h4>
      <ul>
        <li>
          <strong>Account information</strong> — email address and display name when you
          register or log in to the app.
        </li>
        <li>
          <strong>Practice data</strong> — meditation session records stored locally on
          your device via the Bodhi Tree feature. This data is not transmitted to our servers
          unless you choose to link your account.
        </li>
        <li>
          <strong>Device token</strong> — a Firebase Cloud Messaging token used to send
          you push notifications (e.g. Dhamma announcements). This token is associated with
          your account when you log in.
        </li>
        <li>
          <strong>Course registration data</strong> — name, contact details, and any
          other information you provide when registering for a retreat course through the app.
        </li>
        <li>
          <strong>Payment information</strong> — when you pay registration fees in the app,
          payment is processed by a third-party payment provider. We do not store your card
          number or banking details on our servers; we only receive a transaction reference
          and payment status from the payment provider.
        </li>
        <li>
          <strong>AI assistant queries</strong> — questions you submit to the AI assistant
          are sent to our backend for processing. We do not store your queries beyond what is
          necessary to generate a response.
        </li>
      </ul>

      <h4 className="mt-4">2. How We Use Your Information</h4>
      <ul>
        <li>To authenticate your identity when you log in.</li>
        <li>To process your retreat course registration and payment.</li>
        <li>To send you push notifications about Dhamma content and announcements.</li>
        <li>To provide AI-generated responses within the app.</li>
        <li>To improve the app.</li>
      </ul>

      <h4 className="mt-4">3. AI-Generated Content</h4>
      <p>
        The GoDhamma app includes an AI assistant feature. Questions you submit are sent to
        our backend and processed by an AI model. Responses are AI-generated and may not
        always be accurate. We recommend verifying important Dhamma questions with a
        qualified teacher.
      </p>

      <h4 className="mt-4">4. Data Sharing</h4>
      <p>
        We do not sell your personal data. We share data only with:
      </p>
      <ul>
        <li>
          <strong>Firebase (Google)</strong> — for push notification delivery. Firebase's
          privacy policy is available at{' '}
          <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noreferrer">
            firebase.google.com/support/privacy
          </a>.
        </li>
        <li>
          <strong>Payment processors</strong> — your payment is handled directly by our
          third-party payment provider. We only receive a transaction reference and status;
          your card or banking details never pass through our servers. The payment provider's
          own privacy policy governs how they handle your financial data.
        </li>
        <li>
          <strong>Service providers</strong> — hosting and infrastructure providers who
          process data on our behalf under confidentiality agreements.
        </li>
      </ul>

      <h4 className="mt-4">5. Data Retention</h4>
      <p>
        Account data is retained for as long as your account is active, or until you request
        deletion. Practice data is stored locally on your device and is removed when you
        uninstall the app or request account deletion.
      </p>

      <h4 className="mt-4">6. Your Rights</h4>
      <p>You have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you.</li>
        <li>Request correction of inaccurate data.</li>
        <li>
          Request deletion of your account and associated data — see our{' '}
          <a href="/retreat-my/delete-account">account deletion page</a>.
        </li>
        <li>Withdraw consent for push notifications at any time via your device settings.</li>
      </ul>

      <h4 className="mt-4">7. Security</h4>
      <p>
        Authentication tokens are stored using encrypted secure storage on your device.
        All communications between the app and our servers use HTTPS.
      </p>

      <h4 className="mt-4">8. Changes to This Policy</h4>
      <p>
        We may update this policy from time to time. Changes will be posted on this page
        with an updated date. Continued use of the app after changes constitutes acceptance
        of the updated policy.
      </p>

      <h4 className="mt-4">9. Contact Us</h4>
      <p>
        For any privacy-related questions or to exercise your data rights, please contact:
      </p>
      <address>
        <strong>Pertubuhan Meditasi Shi Ne Ling, Malaysia</strong><br />
        Email: <a href="mailto:app@shineling.org">app@shineling.org</a><br />
        Website: <a href="https://www.shineling.org" target="_blank" rel="noreferrer">www.shineling.org</a>
      </address>
    </div>
  );
};

export default PrivacyPolicy;
